/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './patient-procedure-order.reducer';

export const PatientProcedureOrderDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const patientProcedureOrderEntity = useAppSelector(state => state.patientProcedureOrder.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="patientProcedureOrderDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.patientProcedureOrder.detail.title">PatientProcedureOrder</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.patientProcedureOrder.id">Id</Translate>
            </span>
          </dt>
          <dd>{patientProcedureOrderEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.patientProcedureOrder.active">Active</Translate>
            </span>
          </dt>
          <dd>{patientProcedureOrderEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.patientProcedureOrder.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{patientProcedureOrderEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.patientProcedureOrder.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{patientProcedureOrderEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.patientProcedureOrder.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{patientProcedureOrderEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.patientProcedureOrder.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{patientProcedureOrderEntity.cursor}</dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.patientProcedureOrder.addedByType">Added By Type</Translate>
            </span>
          </dt>
          <dd>{patientProcedureOrderEntity.addedByType}</dd>
          <dt>
            <span id="addedByID">
              <Translate contentKey="tinyMedicRestApp.patientProcedureOrder.addedByID">Added By ID</Translate>
            </span>
          </dt>
          <dd>{patientProcedureOrderEntity.addedByID}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.patientProcedureOrder.modifiedByType">Modified By Type</Translate>
            </span>
          </dt>
          <dd>{patientProcedureOrderEntity.modifiedByType}</dd>
          <dt>
            <span id="modifiedByID">
              <Translate contentKey="tinyMedicRestApp.patientProcedureOrder.modifiedByID">Modified By ID</Translate>
            </span>
          </dt>
          <dd>{patientProcedureOrderEntity.modifiedByID}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientProcedureOrder.procedure">Procedure</Translate>
          </dt>
          <dd>{patientProcedureOrderEntity.procedure ? patientProcedureOrderEntity.procedure.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientProcedureOrder.patient">Patient</Translate>
          </dt>
          <dd>{patientProcedureOrderEntity.patient ? patientProcedureOrderEntity.patient.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/patient-procedure-order" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/patient-procedure-order/${patientProcedureOrderEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PatientProcedureOrderDetail;
